import {v4 as guid} from "uuid";
import firebase from "../fire";

const db = firebase.firestore();

export const splitThemeContentIntoChunksAsync = async (lecture) => {
    const themeChunkSize = 1_000_000;

    for (const theme of lecture.themes.filter(x => !!x.content && x.content.length > themeChunkSize)) {

        const chunkCount = Math.ceil(theme.content.length / themeChunkSize);
        const chunks = [];

        for (let i = 0; i < chunkCount; i++) {
            const chunkStartIndex = i * themeChunkSize;
            const chunkEndIndex = chunkStartIndex + themeChunkSize;

            chunks.push({
                id: guid(),
                value: theme.content.substring(chunkStartIndex, chunkEndIndex)
            });

            for (const chunk of chunks) {
                await db.collection("themeContentChunks").doc(chunk.id).set(chunk);
            }
        }

        theme.content = "";
        theme.chunkIds = [...chunks.map(x => x.id)];
    }
};

export const joinThemeContentFromChunksAsync = async (lecture) => {
    for (const theme of lecture.themes.filter(x => !!x.chunkIds && x.chunkIds.length > 0)) {
        const chunks = [];

        for (const chunkId of theme.chunkIds) {
            const ch = (await db.collection("themeContentChunks").doc(chunkId).get()).data();
            chunks.push(ch);
        }

        theme.content = chunks.map(x => x.value).join("");
    }
};